import jwtDecode, { JwtPayload } from 'jwt-decode';

import { ClientKind } from '../api/enumerations';
import { getLocalStorageToken } from '../helpers/localStorage';

export interface CompaniesProps {
  bank_client_kind: ClientKind | null;
  is_hive_owner: boolean;
  /** Hive owner that serves several banks; single bank fixes client_name (REAL-3265). */
  is_multi_bank?: boolean;
  is_responsible_user: boolean;
  name: string;
  role: number;
  subdomain: string;
}
interface TokenProps extends JwtPayload {
  exp: number;
  user: {
    companies: CompaniesProps[];
    email: string;
    id: number;
    name: string;
    session_id: number;
  };
}

interface StoragedJwtProps {
  expired: boolean;
  user: {
    companies: CompaniesProps[];
    email: string;
    id: number;
    name: string;
    session_id: number;
  };
}

export function useStoragedJwt(): StoragedJwtProps | null {
  const jwtToken = getLocalStorageToken();

  if (!jwtToken) {
    return null;
  }

  const decoded = jwtDecode<TokenProps>(jwtToken);
  const expirationTime = decoded.exp;
  const now = new Date().getTime() / 1000;
  const expired = now > expirationTime;

  const storagedData = {
    expired,
    user: decoded.user,
  };

  return storagedData;
}
